import { render, staticRenderFns } from "./UserRegistration.vue?vue&type=template&id=14d5dc2c&scoped=true&lang=html&"
import script from "./UserRegistration.vue?vue&type=script&lang=js&"
export * from "./UserRegistration.vue?vue&type=script&lang=js&"
import style0 from "./UserRegistration.vue?vue&type=style&index=0&id=14d5dc2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d5dc2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VLayout,VTextField})
